var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67982 14H14.3202C15.6128 14 16.4185 12.6253 15.7722 11.5305L9.45205 0.821108C8.80576 -0.273703 7.19424 -0.273703 6.54795 0.821108L0.227771 11.5305C-0.418516 12.6253 0.387244 14 1.67982 14ZM8 8.23784C7.53837 8.23784 7.16067 7.86741 7.16067 7.41467V5.76834C7.16067 5.3156 7.53837 4.94517 8 4.94517C8.46163 4.94517 8.83933 5.3156 8.83933 5.76834V7.41467C8.83933 7.86741 8.46163 8.23784 8 8.23784ZM8.83933 11.5305H7.16067V9.88417H8.83933V11.5305Z",
    fill: "#FF9800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a684afe32a636fc35ada8306083f2ee3.svg";
export { ForwardRef as ReactComponent };